import { render, staticRenderFns } from "./unifromOrder.vue?vue&type=template&id=5341ad0e&scoped=true&"
import script from "./unifromOrder.vue?vue&type=script&lang=js&"
export * from "./unifromOrder.vue?vue&type=script&lang=js&"
import style0 from "./unifromOrder.vue?vue&type=style&index=0&id=5341ad0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341ad0e",
  null
  
)

export default component.exports